module.exports = __webpack_public_path__ + "img/hr-level1_running_mask.9791a373.png";